function toStringNormalized(literal) {
    var plain = '';
    if (typeof literal === 'object') {
        const arr = Array.isArray(literal);
        plain = plain + (arr ? '[' : '{');
        var keys = Object.keys(literal);
        keys.sort();
        let c = 0;
        keys.forEach(key => {
            plain = plain +
                (arr ? '' : escapeString(key) + ':') + toStringNormalized(literal[key]);
            c = c + 1;
            if (c < keys.length) {
                plain = plain + ',';
            }
        });
        plain = plain + (arr ? ']' : '}');
    }
    else if (typeof literal === 'string') {
        plain = escapeString(literal);
    }
    else if (typeof literal === 'boolean') {
        plain = literal.toString();
    }
    else if (typeof literal === 'number') {
        if (!Number.isFinite(literal)) {
            throw new Error('Cannot serialize ' + literal + ': NaN and Infinity are not valid Literals.');
        }
        plain = Object.is(literal, -0) ? '0' : literal.toString();
    }
    else {
        throw new Error('Cannot serialize ' + literal + ', its type ' + (typeof literal) + ' is illegal for a literal.');
    }
    return plain;
}
function escapeString(text) {
    return '"' + text.replaceAll("\\", "\\\\").replaceAll('"', '\\"') + '"';
}
function eq(a, b) {
    return toStringNormalized(a) === toStringNormalized(b);
}
function strongEq(a, b) {
    if (a === undefined && b === undefined) {
        return true;
    }
    if (a === undefined || b === undefined) {
        return false;
    }
    return eq(a, b);
}
export { toStringNormalized, eq, strongEq };
